import { useNavigate } from "react-router-dom";
import DashboardPanelSwitcher from "../Common/DashboardPanelSwitcher";
import "../FridayDashboard/FridayDashboard.css";

const DEPARTMENT_CARDS = [
  {
    title: "Sales & Marketing",
    description: "Sales, brand, field diagnosis, division performance, executive insights, semantic query, thinking query, and chat.",
    path: "/dashboard",
  },
  {
    title: "Finance",
    description: "Finance analytics workspace. Dashboards will appear here when enabled.",
    path: null,
  },
  {
    title: "Supply Chain",
    description: "Supply chain analytics workspace. Dashboards will appear here when enabled.",
    path: null,
  },
  {
    title: "Emerging Market",
    description: "Emerging market analytics workspace. Dashboards will appear here when enabled.",
    path: null,
  },
  {
    title: "Manufacturing",
    description: "Manufacturing analytics workspace. Dashboards will appear here when enabled.",
    path: null,
  },
];

export default function DepartmentHome() {
  const navigate = useNavigate();

  return (
    <section className="friday-dashboard-home departments-home">
      <div className="departments-topbar">
        <div className="friday-dashboard-logo departments-logo">
          Emcure
          <span>Department Workspaces</span>
        </div>
        <DashboardPanelSwitcher direction="down" />
      </div>

      <div className="friday-dashboard-home-content departments-home-content">
        <h1>Departments</h1>
        <p>
          Choose a business department workspace. Sales & Marketing opens the existing dashboard suite with the new query and chat cards.
        </p>

        <div className="friday-dashboard-card-grid">
          {DEPARTMENT_CARDS.map((item) => {
            const disabled = !item.path;
            return (
              <button
                key={item.title}
                type="button"
                className={`friday-dashboard-card${disabled ? " friday-dashboard-card--disabled" : ""}`}
                onClick={() => {
                  if (!disabled) navigate(item.path);
                }}
                disabled={disabled}
              >
                <strong>{item.title}</strong>
                <span>{item.description}</span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
